const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function request(path, options, retries = 2) {
  let res;
  try {
    res = await fetch(`${API}${path}`, options);
  } catch (e) {
    if (retries > 0) {
      await new Promise((r) => setTimeout(r, 1500));
      return request(path, options, retries - 1);
    }
    throw new Error('Connection issue — please try again in a moment.');
  }
  if (!res.ok) {
    if (res.status >= 500 && retries > 0) {
      await new Promise((r) => setTimeout(r, 1500));
      return request(path, options, retries - 1);
    }
    let msg = 'Request failed';
    try {
      const data = await res.json();
      msg = data.detail || data.message || msg;
    } catch (e) { /* keep default */ }
    throw new Error(msg);
  }
  try {
    return await res.json();
  } catch (e) {
    throw new Error('Unexpected response — please try again.');
  }
}

export const getConfig = () => request('/config');
export const getCategories = () => request('/categories');

export function getProducts(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.set(k, v);
  });
  return request(`/products?${q.toString()}`);
}

export const getProduct = (slug) => request(`/products/${slug}`);
export const getDeals = () => request('/deals');

export const checkArea = (payload) =>
  request('/service-area/check', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

export const uploadId = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return request('/uploads/id', { method: 'POST', body: fd });
};

export const createOrder = (payload) =>
  request('/orders', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

export const getBlogPosts = () => request('/blog/posts');
export const getBlogPost = (slug) => request(`/blog/posts/${slug}`);
